export const GET_SHOP_REQUEST = "GET_SHOP_REQUEST"
export const GET_SHOP_SUCCESS = "GET_SHOP_SUCCESS"
export const GET_SHOP_FAIL = "GET_SHOP_FAIL"

export const GET_SHOP_DETAILS_REQUEST = "GET_SHOP_DETAILS_REQUEST"
export const GET_SHOP_DETAILS_SUCCESS = "GET_SHOP_DETAILS_SUCCESS"
export const GET_SHOP_DETAILS_FAIL = "GET_SHOP_DETAILS_FAIL"